import { Dispatch } from 'react'
import { axiosInstance } from '../util/axios.js'
import { networkType } from '../util/types.js'

export const getRefreshedToken = async (dispatch: Dispatch<any>) => {
  try {
    const storedAuthStateJson =
      sessionStorage.getItem('authState') || localStorage.getItem('authState')
    const storedAuthState = storedAuthStateJson ? JSON.parse(storedAuthStateJson) : null
    const rememberMe = storedAuthState?.user?.rememberMe || false
    const refreshToken = storedAuthState?.user?.refreshToken || ''
    const response = await axiosInstance.post('/public/refreshSession', {
      refreshToken,
    })

    const newToken = response?.data?.data?.token
    if (newToken) {
      storedAuthState.user.accessToken = newToken
      rememberMe
        ? localStorage.setItem('authState', JSON.stringify(storedAuthState))
        : sessionStorage.setItem('authState', JSON.stringify(storedAuthState))

      dispatch({
        type: 'UPDATE_TOKEN',
        payload: {
          accessToken: response?.data?.data?.token,
        },
      })
    }

    return newToken
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const createProject = async (
  payload: any,
  txHash: string,
  projectType: string,
  abi?: any[],
) => {
  try {
    const res = await axiosInstance.post('/blockchain-helpers/external/createProject', {
      data: payload,
      txHash,
      projectType,
      ...(payload?.scAddress ? { scAddress: payload?.scAddress } : {}),
      ...(abi ? { abi } : {}),
    })
    return res.data.data
  } catch (error) {
    // Dispatch failure action
    console.error(error)
    throw error
  }
}

export const getNftCollections = async (address: string, network: networkType) => {
  try {
    const response = await axiosInstance.get(
      `https://${
        network === 'mainnet' ? '' : 'devnet-'
      }api.multiversx.com/accounts/${address}/roles/collections`,
    )
    return response.data
  } catch (error) {
    // Dispatch failure action
    console.error(error)
  }
}
